'use strict';

class AccordionPdp {
    setup () {
        this.init();
        var _closeAllAcordion = this.closeAllAcordionItems;

        $('.accordion-pdp').on('click', '.accordion-item:not(.active, .not-expandible) .accordion-title', function (e) {
            e.preventDefault();
            const $accordion = $(this).closest('.accordion-pdp');
            const $item = $(this).closest('.accordion-item');
            const $content = $(this).next('.accordion-content');

            const closeAllOpenPanels = !$accordion.hasClass('multiple-panels');
            const closeButshipping = !$item.hasClass('accordion-shipping');

            if (closeAllOpenPanels && closeButshipping) {
                _closeAllAcordion($accordion);
            }

            $item.addClass('active');
            $content.slideDown({
                progress: function () {
                    if ($item.offset().top < ($(window).scrollTop() + $('header').height())) {
                        window.scrollTo(0, ($item.offset().top - $('header').height()));
                    }
                }
            });
        });
        // close at click
        $('.accordion-pdp').on('click', '.accordion-item.active .accordion-title', function (e) {
            e.preventDefault();
            $(this).next('.accordion-content').slideUp('fast');
            $(this).closest('.accordion-item').removeClass('active');
        });

        $(window).on('changed.zf.mediaquery', () => {
            this.init();
        });

        $('.accordion-item[data-open-on-init="true"]').find('.accordion-title').trigger('click');
    }

    init () {
        $('.accordion-pdp').each(function () {
            const $accordion = $(this).closest('.accordion-pdp');
            const breakpoint = $accordion.data('accordion-size');

            if (breakpoint === 'small' && !Foundation.MediaQuery.atLeast('medium')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'medium' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint === 'tablet' && !Foundation.MediaQuery.atLeast('large')) {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            } else if (breakpoint !== 'all') {
                $accordion.removeClass('initialized');
                $accordion.find('.accordion-content').show();
            } else if (breakpoint === 'all') {
                $accordion.addClass('initialized');
                $accordion.find('.accordion-content').hide();
            }
        });

        let limitAccordion = 70;

        if (($('.accordion-pdp .accordion-description .accordion-content .pdp-html-description').innerHeight() + $('.accordion-pdp .accordion-description .accordion-content p').innerHeight()) < limitAccordion) {
            $('.accordion-pdp .accordion-description .accordion-title').addClass('little');
            $('.accordion-pdp').on('click', '.accordion-description.accordion-item:not(.active, .not-expandible) .accordion-title', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            });
        } else {
            $('.accordion-pdp .accordion-description .accordion-content p').css('-webkit-line-clamp', '3');
        }
    }

    closeAllAcordionItems ($accordionContainer) {
        $accordionContainer.find('.accordion-content:not(.accordion-shipping)').slideUp('fast');
        $accordionContainer.find('.accordion-item:not(.accordion-shipping)').removeClass('active');
    }
}

const accordionPdp = new AccordionPdp();
export default accordionPdp;
